import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "full", "button"]

  toggle() {
    const showFull = this.fullTarget.classList.contains("hidden")
    this.fullTarget.classList.toggle("hidden", !showFull)
    this.previewTarget.classList.toggle("hidden", showFull)
    this.buttonTarget.textContent = showFull ? "less" : "more"
  }
}
